import * as selectors from './competitors-selectors';

export const Competitors = {
    ...selectors,
} as const;
